export class LabTestCategoryModel {
  public id: string;
  public name: string;
  public description: string;
  public isSelected: boolean;
  public inClinicTest: boolean;

  constructor(id: string = '', name: string = '', description: string = '', isSelected: boolean = false) {
    this.id = id;
    this.name = name;
    this.description = description;
    this.isSelected = isSelected;
    this.inClinicTest = false;
  }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/models/master-data/labtest-category.model.ts